module.exports = __webpack_public_path__ + "img/3-remind.4e9253eb.jpg";